import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { FiTrash } from "react-icons/fi";
import { LuCopy } from "react-icons/lu";
import { IoIosArrowDroprightCircle, IoMdInformationCircleOutline } from "react-icons/io";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import { FaCirclePlus } from "react-icons/fa6";
import AutoSave from "../../../components/forms/AutoSave";
import FormDropdown from "../../../components/forms/FormDropdown";
import Modal from "../../../components/Modal";
import {
  initializeWpsTableData,
  resetWpsTableData,
  addWpsRow,
  setWpsSampleAmount,
  editWpsRow,
  copyWpsRow,
  deleteWpsRow,
  increaseWpsConcentration,
  decreaseWpsConcentration,
  clearWpsSelect,
  setWpsComments,
	setWpsServiceOption,
	clearWpsServiceOption,
} from "../../../store";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Alert from "../../../components/Alert";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { FaArrowCircleDown, FaRegTimesCircle } from "react-icons/fa";

const SampleInformation = ({ page, handleNextPage, progress }) => {
  const dispatch = useDispatch();
  const wpsWhole = useSelector((state) => state.wpsForm);
  const wpsState = useSelector((state) => state.wpsForm.data);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
  const [isSampleIDModalOpen, setIsSampleIDModalOpen] = useState(false);
  const [isSampleTypeModalOpen, setIsSampleTypeModalOpen] = useState(false);
  const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);

  const [errors, setErrors] = useState({});
  const [tableErrors, setTableErrors] = useState([]);
	const [showSampleIdError, setShowSampleIdError] = useState(false);
	
  const [isOpenServiceModal, setIsOpenServiceModal] = useState(false);

  //Variables for Table Data
  const propertiesToShow = [
    "id",
    "sampleID",
	"sampleType",
    "sampleConc",
    "targetSize",
    // "dataAnalysis",
  ];

  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  const sampleTypes = [
    { value: 1, label: "Plasmid" },
	{ value: 2, label: "DNA fragment > 1 Kb" },
	{ value: 3, label: "Culture" },
	];
  
	const sampleTypes1 = [
		{ value: 1, label: "Plasmid" },
		{ value: 3, label: "Culture" },
	];
	
	const sampleTypes2 = [
		{ value: 2, label: "DNA fragment > 1 Kb" },
	];

  // same as 21
  // const dataAnalysisType31 = [
  //   { value: 1, label: "Map to Reference" },
  //   { value: 2, label: "de novo" },
  // ];
 

  const dataAnalysisTypeDefault = [
    // { value: 1, label: "Map to Reference" },
    { value: 2, label: "de novo" },
  ];

	const serviceOption = [
		{ value: 1, label: "Plasmid" },
		{ value: 2, label: "Amplicon" },
	]

  const [isChecked, setIsChecked] = useState(false);


  //Create Table Data
  const handleSubmit = (count) => {
    if (wpsState.sampleAmount === "") {
      alert("Missing Input");
    } else {
      if (wpsState.sampleAmount) {
        dispatch(resetWpsTableData([]));
        dispatch(initializeWpsTableData(count));
      } else {
        dispatch(initializeWpsTableData(count));
      }
    }
  };

  //Handle Table Data Input
  const handleInputChange = (index, event, property, option) => {
    if (property === "sampleType" || property === "dataAnalysis") {
      let value = option ? option : ""; // If option is truthy, use its label; otherwise, use an empty string
      dispatch(editWpsRow({ index, value, property }));
    } else {
      let value = event.target.value;
      dispatch(editWpsRow({ index, value, property }));
    }
  };

  //Handle row hover copy and delete
  const handleRowHover = (index) => {
    setHoveredRow(index);
  };

  const handleDeleteRow = (index) => {
    dispatch(deleteWpsRow({ index }));
  };

  const handleCopyRow = (index) => {
    dispatch(copyWpsRow({ index }));
    setTableErrors((prev) =>
      prev.map((rowErrors, idx) => {
        if (idx === index + 1 && rowErrors[index + 1] !== "") {
          return {
            ...rowErrors,
            dataAnalysis: "",
            sampleID: "",
            sampleConc: "",
            sampleType: "",
            targetSize: "",
          };
        }
        return rowErrors;
      })
    );
  };

  const handleAddRow = () => {
    const newRow = {
      id: null,
      sampleID: "",
      sampleConc: "",
      sampleType: "",
      targetSize: "",
      dataAnalysis: "",
      orderId: 0,
    };
    dispatch(addWpsRow(newRow));
  };

  const handleIncreaseConcentration = (index, property) => {
    dispatch(increaseWpsConcentration({ index, property }));
  };

  const handleDecreaseConcentration = (index, property) => {
    dispatch(decreaseWpsConcentration({ index, property }));
  };

  const handleComments = (event) => {
    dispatch(setWpsComments(event.target.value));
  };

  const handleTargetOpen = () => {
    setIsTargetModalOpen(true);
  };

  const handleTargetClose = () => {
    setIsTargetModalOpen(false);
  };

  const handleSampleIDOpen = () => {
    setIsSampleIDModalOpen(true);
  };

  const handleSampleIDClose = () => {
    setIsSampleIDModalOpen(false);
  };

  const handleSampleTypeOpen = () => {
    setIsSampleTypeModalOpen(true);
  };

  const handleSampleTypeClose = () => {
    setIsSampleTypeModalOpen(false);
  };

  const handleAnalysisOpen = () => {
    setIsAnalysisModalOpen(true);
  };

  const handleAnalysisClose = () => {
    setIsAnalysisModalOpen(false);
  };

  // console.log(errors);
  // console.log(tableErrors);

  const handleServiceModalClose = () => {
    setIsOpenServiceModal(false);
  };
  

  const FixedRow = () => (
    <tr>
      <td></td>
      <td className=' font-bold border-l border-b border-gray-300 h-10 py-2 px-4 text-xl text-gray-600 bg-gray-200 w-[40px]'>
        <div className='flex justify-center items-center'>
          {wpsState.serviceOption === "" || wpsState.servicePriority === 0 ? (
            <FaCirclePlus className=' cursor-not-allowed' />
          ) : (
            <FaCirclePlus onClick={handleAddRow} className=' cursor-pointer' />
          )}
        </div>
      </td>
      <td className=' font-bold border-b border-gray-300 h-10 p-2 bg-gray-200'>
        <div className='flex justify-start items-center text-gray-600 uppercase'>Add Row</div>
      </td>
      <td className=' font-bold border-b border-gray-300 h-10 py-2 px-4 bg-gray-200'></td>
      {/* <td className=' font-bold border-b border-gray-300 h-10 py-2 px-4 bg-gray-200'></td> */}
      <td className=' font-bold border-b border-gray-300 h-10 py-2 px-4 bg-gray-200'></td>
      <td className=' font-bold border-r border-b border-gray-300 h-10 py-2 px-4 bg-gray-200'></td>
    </tr>
  );

  const renderedRows = [
    ...wpsState.tableData.map((item, index) => (
      <tr
        key={item.id}
        onMouseEnter={() => handleRowHover(index)}
        onMouseLeave={() => handleRowHover(null)}
      >
        <td className='w-[70px] xl:w-[85px]'>
          {hoveredRow === index ? (
            <div className='flex justify-around items-center border-2 rounded-full '>
              <div className='flex items-center justify-center h-full w-full hover:bg-gray-300 p-2 rounded-l-full '>
                <button className='text-black ' onClick={() => handleCopyRow(index)}>
                  <LuCopy />
                </button>
              </div>
              <hr className='border-[1px] border-[var(--color-primary-purple)] h-full' />
              <div className='flex items-center justify-center h-full w-full hover:bg-gray-300 p-2 rounded-r-full'>
                <button className='text-black ' onClick={() => handleDeleteRow(index)}>
                  <FiTrash />
                </button>
              </div>
            </div>
          ) : (
            // <button
            //   className='text-white cursor-default select-none'
            //   onClick={() => handleDeleteRow(index)}
            // >
            //   Delete
            // </button>
             <div className='flex justify-around items-center border-2 rounded-full opacity-0 pointer-events-none'>
              <div className='flex items-center justify-center h-full w-full hover:bg-gray-300 p-2 rounded-l-full '>
                <button className='text-black ' >
                  <LuCopy />
                </button>
              </div>
              <hr className='border-[1px] border-[var(--color-primary-purple)] h-full' />
              <div className='flex items-center justify-center h-full w-full hover:bg-gray-300 p-2 rounded-r-full'>
                <button className='text-black '>
                  <FiTrash />
                </button>
              </div>
            </div>
          )}
        </td>
        {propertiesToShow.map((property) => (
          <td key={property} className='p-0'>
            {property === "sampleID" ? (
              <input
                className={`min-h-10 py-2 px-4 border-[1px] ${
                  tableErrors[index] && tableErrors[index].sampleID
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } w-full`}
                type='text'
                value={item[property]}
                maxLength={40}
                onChange={(e) => {
                  if (tableErrors[index] && tableErrors[index].sampleID !== "") {
                    setTableErrors((prev) => [...prev, (prev[index]["sampleID"] = "")]);
                    // setTableErrors({
                    //   ...tableErrors,
                    //   [index]: {
                    //     ...tableErrors[index],
                    //     sampleID: ""
                    //   }
                    // });
					}
					setShowSampleIdError(false)
                  handleInputChange(index, e, property);
                }}
              />
            ) 
            : property === "targetSize" ? (
              <div
                className={`flex min-h-10 pl-4 border-[1px] ${
                  tableErrors[index] && tableErrors[index].targetSize
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
                } xl:min-w-32`}
              >
                <input
                  type='number'
                  className={`py-2 w-[88%] focus:outline-none ${
                  tableErrors[index] && tableErrors[index].targetSize
                    ? "bg-red-200"
                    : ""
                }`}
                  min={1}
                  value={item[property]}
                  placeholder={"Between 1Kb - 200Kb"}
                  onChange={(e) => {
                    if (tableErrors[index] && tableErrors[index].targetSize !== 0) {
                      setTableErrors((prev) => [...prev, (prev[index]["targetSize"] = 0)]);
                      // setTableErrors({
                      //   ...tableErrors,
                      //   [index]: {
                      //     ...tableErrors[index],
                      //     targetSize: ""
                      //   }
                      // });
                    }
                    handleInputChange(index, e, property);
                  }}
                />
                <div className='flex flex-col justify-around items-center w-1/5 bg-gray-100'>
                  <button>
                    <BiSolidUpArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].targetSize !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["targetSize"] = "")]);
                          // setTableErrors({
                          //   ...tableErrors,
                          //   [index]: {
                          //     ...tableErrors[index],
                          //     targetSize: ""
                          //   }
                          // });
                        }
                        handleIncreaseConcentration(index, property);
                      }}
                    />
                  </button>
                  <button>
                    <BiSolidDownArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].targetSize !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["targetSize"] = "")]);
                          // setTableErrors({
                          //   ...tableErrors,
                          //   [index]: {
                          //     ...tableErrors[index],
                          //     targetSize: ""
                          //   }
                          // });
                        }
                        handleDecreaseConcentration(index, property);
                      }}
                    />
                  </button>
                </div>
              </div>
            )
            : property === "sampleConc" ? (
              <div
                className={`flex min-h-10 pl-4 border-[1px] ${
                  tableErrors[index] && tableErrors[index].sampleConc
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
				} ${item["sampleType"].value===3 ? 'bg-gray-200 pointer-events-none':''} xl:min-w-32`}
              >
                <input
					type='number'
					disabled={item["sampleType"].value===3}
                  className={`py-2 w-[88%] focus:outline-none  ${
                  tableErrors[index] && tableErrors[index].sampleConc
                    ? "bg-red-200"
                    : ""
				} ${item["sampleType"].value===3 ? 'text-gray-200':''}`}
                  min={0}
                  value={item[property]}
                  onChange={(e) => {
                    if (tableErrors[index] && tableErrors[index].sampleConc !== 0) {
                      setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = 0)]);
                    }
                    handleInputChange(index, e, property);
                  }}
                />
                <div className='flex flex-col justify-around items-center w-1/5 bg-gray-100'>
                  <button>
                    <BiSolidUpArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].sampleConc !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = "")]);
                        }
                        handleIncreaseConcentration(index, property);
                      }}
                    />
                  </button>
                  <button>
                    <BiSolidDownArrow
                      className=' text-xs text-[var(--color-primary-purple)]'
                      onClick={() => {
                        if (tableErrors[index] && tableErrors[index].sampleConc !== 0) {
                          setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = "")]);
                        }
                        handleDecreaseConcentration(index, property);
                      }}
                    />
                  </button>
                </div>
              </div>
            ) 
            : property === "sampleType" ? (
              <div
                className={`min-h-10 border-[1px]  ${
                  tableErrors[index] && tableErrors[index].sampleType
                    ? "border-red-500 bg-red-200"
                    : "border-gray-300"
				} xl:min-w-[174px]`}
				onClick={() => {
					if(wpsState.serviceOption === null || wpsState.serviceOption === ''){
						setErrors({...errors, serviceOption: 'Please select'})
					}
				}}
              >
                <FormDropdown
					options={wpsState.serviceOption.value === 2 ? sampleTypes2 : wpsState.serviceOption.value === 1 ? sampleTypes1 : [] }
                  onSelect={(option) => {
                    if (tableErrors[index] && tableErrors[index].sampleType !== "") {
                      setTableErrors((prev) => [...prev, (prev[index]["sampleType"] = "")]);
                      // setTableErrors({
                      //   ...tableErrors,
                      //   [index]: {
                      //     ...tableErrors[index],
                      //     sampleType: ""
                      //   }
                      // });
                    }
                    // dispatch(clearWpsSelect({index, property:'dataAnalysis'}))
					handleInputChange(index, null, property, option);
					if(option.value===3){
						dispatch(editWpsRow({ index, value:0, property:"sampleConc" }));
						if (tableErrors[index] && tableErrors[index].sampleConc !== "") {
							setTableErrors((prev) => [...prev, (prev[index]["sampleConc"] = "")]);
						}
					}
                  }}
                  index={index}
                  property={property}
                  selectedOption={item[property]}
                  clearSelect={() => {
                    dispatch(clearWpsSelect({ index, property }));
                  }}
                />
              </div>
            ) 
            // : property === "dataAnalysis" ? (
            //   <div
            //     className={`min-h-10 border-[1px]  ${
            //       tableErrors[index] && tableErrors[index].dataAnalysis
            //         ? "border-red-500 bg-red-200"
            //         : "border-gray-300"
            //     } xl:min-w-[166px]`}
            //   >
            //     <FormDropdown
            //       options={dataAnalysisTypeDefault}
            //       onSelect={(option) => {
            //         if (tableErrors[index] && tableErrors[index].dataAnalysis !== "") {
            //           setTableErrors((prev) => [...prev, (prev[index]["dataAnalysis"] = "")]);
            //           // setTableErrors({
            //           //   ...tableErrors,
            //           //   [index]: {
            //           //     ...tableErrors[index],
            //           //     dataAnalysis: ""
            //           //   }
            //           // });
            //         }
            //         handleInputChange(index, null, property, option);
            //       }}
            //       index={index}
            //       property={property}
            //       selectedOption={item[property]}
            //       clearSelect={() => dispatch(clearWpsSelect({ index, property }))}
            //     />
            //   </div>
            // ) 
            : property === "id" ? (
              <div className=' text-center font-bold min-h-10 py-2 px-4 border-[1px] border-gray-300 min-w-[65px]'>
                {item[property]}
              </div>
            ) : null}
          </td>
        ))}
      </tr>
    )),
    <FixedRow key='fixed-row' />,
  ];
	
	const sampleIdCount = wpsState.tableData.reduce((acc, row) => {
	if (row.sampleID) {
		acc[row.sampleID] = (acc[row.sampleID] || 0) + 1;
	}
	return acc;
	}, {});
	
  const validateWps = () => {
    const newErrors = {};

	if (!wpsState.serviceOption) {
		newErrors.serviceOption = "Please select";
	}
    
    if (!wpsState.sampleAmount) {
      newErrors.sampleAmount = "Please enter";
    }
    else if(wpsState.sampleAmount > 0 && wpsState.tableData.length === 0){
      newErrors.sampleAmount = "Click on the button to initiate the table"
    }

    if (wpsState.sampleAmount > 0) {
      const newTableErrors = wpsState.tableData.map((row) => {
        const rowErrors = {};
		if (!row.sampleID) {
				rowErrors.sampleID = "Please enter";
		} 	else if(String(row.sampleID).length >30) {
				rowErrors.sampleID  = "Please enter";
		}	else if (sampleIdCount[row.sampleID] > 1) {
				rowErrors.sampleID = "Duplicate sampleID not allowed";
		}

		
        if (!row.sampleType) rowErrors.sampleType = "Please select";
		if (row.sampleType.value !== 3 && !row.sampleConc) rowErrors.sampleConc = "Please select";
        if (!row.targetSize) {
          rowErrors.targetSize = "Please enter";
        } 
        else if(parseInt(row.targetSize) <= 0 || parseInt(row.targetSize) > 200){
          rowErrors.targetSize = "Please enter";
        }
        // if (!row.dataAnalysis) rowErrors.dataAnalysis = "Please select";

        return rowErrors;
      });

      return { newErrors, newTableErrors };
    } else {
      return { newErrors: newErrors };
    }
  };

  const validateAllInputs = () => {
    const validationErrors = validateWps();
    // console.log("here", validationErrors);

    if (validationErrors.newTableErrors) {
      if (
        Object.keys(validationErrors.newErrors).length > 0 ||
        validationErrors.newTableErrors.some((row) => Object.keys(row).length > 0)
      ) {
        setErrors(validationErrors.newErrors);
		setTableErrors(validationErrors.newTableErrors);
		
		if(validationErrors.newTableErrors.some(obj => obj.sampleID !== undefined && obj.sampleID !== '')){          
          setShowSampleIdError(true)
        }
		
      } else {
        if(!isChecked){
          setErrors({...errors, isChecked: 'Please check the box'})
        }
        else{
          // console.log("Pass");
          handleNextPage();
        }
      }
    } else {
      if (Object.keys(validationErrors.newErrors).length > 0) {
        setErrors(validationErrors.newErrors);
      } else {
        if(!isChecked){
          setErrors({...errors, isChecked: 'Please check the box'})
        }
        else{
          // console.log("Pass");
          handleNextPage();
        }
      }
    }
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const downloadTemplate = () => {
    let fileName = "Whole_Plasmid_Sequencing";
    const link = document.createElement("a");
	link.href = `${process.env.PUBLIC_URL}/forms/WPS_Template_New.xlsx`;
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // console.log(wpsState);

  let [autoRows, setAutoRows] = useState(false);

  //verifying if excel contains these headers
  // let excelHeaders = ["id", "sampleID", "sampleConc", "sampleType", "targetSize", "dataAnalysis"];
  let excelHeaders = ["id", "sampleID", "sampleConc", "sampleType", "targetSize", "dataAnalysis"];

  //comparing the 2 arrays
  const isSubset = (array2) => {
    return array2.every((element) => excelHeaders.includes(element));
  };

  const fillTable = (data) => {
    // console.log(excelHeaders);
    let importedExcelHeaders = Object.keys(data[0]);
    // console.log(importedExcelHeaders);

    let verifyHeaders = isSubset(importedExcelHeaders);

	if (verifyHeaders) {
		
		dispatch(setWpsServiceOption(''));
		
      let tableRows = data.length;
      dispatch(setWpsSampleAmount(tableRows));

      setAutoRows({ bool: true, dataTable: data });
    } else {
      alert("Please download WPS template and fill data");
    }
  };

  useEffect(() => {
    if (autoRows.bool === true) {
      document.querySelector("#sampleAmountButton").click();

      let data = autoRows.dataTable;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let index = i;
          for (let j = 0; j < excelHeaders.length; j++) {
            let value = Object.values(data[i])[j];
            let property = Object.keys(data[i])[j];
			
			if(property === 'sampleType'){
				value = {"value": String(value).includes("Culture")? 3 : String(value).includes("Plasmid")?1:2, "label": value}
			}
			
            setTableErrors([]);
            dispatch(editWpsRow({ index, value, property }));
            setAutoRows(false);
          }
        }
      }
    }
  }, [autoRows]);

  let [draftSuccess,setDraftSuccess] = useState(false)

  const passMessage = (message) => {
    // console.log("message");
    
    if(message === 'success'){
      window.scrollTo({top:200, left:0, behavior:'smooth'})
      setDraftSuccess(true)
      setTimeout(() => {
        setDraftSuccess(false)
      }, 5000)
    }
    else if(message === 'failure'){
      alert("Something went wrong..")
    }
  }


  function seqSampleId(){
    let currentTable = wpsState.tableData

    // console.log(currentTable);
    let property = "sampleID"

    if (currentTable[0].sampleID === "" || currentTable[0] === undefined) {
          for (let index = 0; index < currentTable.length; index++) {
            let value = index + 1;
            // console.log(value);
            dispatch(editWpsRow({ index, value, property }));
    
            setTableErrors((prev) =>
              prev.map((rowErrors, index) => ({
                ...rowErrors,
                sampleID: "",
              }))
            );
          }
        } else {
          let sampleID = currentTable[0].sampleID;
          for (let index = 0; index < currentTable.length; index++) {
            let value = sampleID + "_" + (index+1);
            // let value = dnaName;
            // console.log(value);
            dispatch(editWpsRow({ index, value, property }));
    
          }
          setTableErrors((prev) =>
            prev.map((rowErrors, index) => ({
              ...rowErrors,
              sampleID: "",
            }))
          );
          
        }
  }

  function clearAllSampleId() {
      let currentTable = wpsState.tableData;
      let property = "sampleID";
  
      for (let index = 0; index < currentTable.length; index++) {
        let value = "";
        dispatch(editWpsRow({ index, value, property }));
      }
    }

  
    function seqSampleType() {
      let currentTable = wpsState.tableData;
  
      // console.log(currentTable);
      let property = "sampleType";
      if (currentTable[0].sampleType === "" || currentTable[0] === undefined) {
        alert("Select Sample Type for row 1");
      } else {
        let sampleType = currentTable[0].sampleType;
        for (let index = 0; index < currentTable.length; index++) {
          let value = sampleType;
          // console.log(value);
          dispatch(editWpsRow({ index, value, property }));
  
          setTableErrors((prev) =>
            prev.map((rowErrors, index) => ({
              ...rowErrors,
              sampleType: "",
            }))
          );
        }
      }
    }

  function clearAllSampleType() {
      let currentTable = wpsState.tableData;
      let property = "sampleType";
  
      for (let index = 0; index < currentTable.length; index++) {
        let value = "";
        dispatch(editWpsRow({ index, value, property }));
      }
    }

  function clearAllTargetSize() {
      let currentTable = wpsState.tableData;
      let property = "targetSize";
  
      for (let index = 0; index < currentTable.length; index++) {
        let value = "";
        dispatch(editWpsRow({ index, value, property }));
      }
    }
    
  function clearAllSampleConc() {
      let currentTable = wpsState.tableData;
      let property = "sampleConc";
  
      for (let index = 0; index < currentTable.length; index++) {
        let value = "";
        dispatch(editWpsRow({ index, value, property }));
      }
    }

    function seqTargetSize() {
       let currentTable = wpsState.tableData;
       
      // console.log(currentTable);
      if (currentTable[0].targetSize === "" || currentTable[0] === undefined) {
        alert("Select Target Size for row 1");
      } else {
      let targetSize = currentTable[0].targetSize;
      for (let index = 0; index < currentTable.length; index++) {
        let value = targetSize
        // console.log(value);
        dispatch(editWpsRow({ index, value, property:'targetSize' }));
        
        setTableErrors((prev) =>
          prev.map((rowErrors, index) => ({
            ...rowErrors,
            targetSize: "",
          }))
        );
      }
    }
      
    }

    function seqSampleConc() {
       let currentTable = wpsState.tableData;
       
      // console.log(currentTable);
      if (currentTable[0].sampleConc === "" || currentTable[0] === undefined) {
        alert("Select Sample Conc. for row 1");
      } else {
      let sampleConc = currentTable[0].sampleConc;
      for (let index = 0; index < currentTable.length; index++) {
        let value = sampleConc
        // console.log(value);
        dispatch(editWpsRow({ index, value, property:'sampleConc' }));
        
        setTableErrors((prev) =>
          prev.map((rowErrors, index) => ({
            ...rowErrors,
            sampleConc: "",
          }))
        );
      }
    }
      
    }

  function clearAllDataAnalysis() {
      let currentTable = wpsState.tableData;
      let property = "dataAnalysis";
  
      for (let index = 0; index < currentTable.length; index++) {
        let value = "";
        dispatch(editWpsRow({ index, value, property }));
      }
    }

    function seqDataAnalysis() {
       let currentTable = wpsState.tableData;
       
      // console.log(currentTable);
      if (currentTable[0].dataAnalysis === "" || currentTable[0] === undefined) {
        alert("Select Data Analysis for row 1");
      } else {
      let dataAnalysis = currentTable[0].dataAnalysis;
      for (let index = 0; index < currentTable.length; index++) {
        let value = dataAnalysis
        // console.log(value);
        dispatch(editWpsRow({ index, value, property:'dataAnalysis' }));
        
        setTableErrors((prev) =>
          prev.map((rowErrors, index) => ({
            ...rowErrors,
            dataAnalysis: "",
          }))
        );
      }
    }
      
    }

    const handleMTR = (event) => {
        console.log('test')
		// dispatch(setWpsMTR(event.target.value));
      };


  return (
    <>
      <div className='px-8 xl:px-16'>
        <div>
          <h1 className='text-3xl xl:text-4xl text-[var(--color-primary-purple)] font-black my-[40px]'>
           Whole Plasmid Sequencing
          </h1>
        </div>
        {draftSuccess && 
          <div className="mb-3">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          }

        <p className="lg:hidden font-semibold text-center text-lg mx-5 py-5 bg-gray-100">Please switch to landscape orientation</p>

        <div className="hidden lg:block w-full ">
        {progress}
        <div className='flex justify-between my-[40px]'>
          <div className="flex items-start gap-[100px]">
			<div className='flex flex-col'>
				<div className='flex justify-start gap-[15px] items-baseline w-52 xl:w-72'>
					<label className='xl:text-lg  font-black text-[var(--color-primary-purple)] mb-3'>
						Category:
					</label>
				</div>
				
				<div className='w-52 xl:w-72 border-2 border-[var(--color-primary-purple)] rounded-sm'>
					<FormDropdown
					options={serviceOption}
					onSelect={(option) => {
						setErrors({
							...errors,
							serviceOption: "",
						});
						dispatch(setWpsServiceOption(option));
					
						if(wpsState.tableData.length > 0){
							for(let i=0; i<wpsState.tableData.length; i++){
								if(option.value === 2 && (wpsState.tableData[i].sampleType.label === 'Plasmid' || wpsState.tableData[i].sampleType.label === 'Culture')){
									dispatch(editWpsRow({ index:i, value:'', property:'sampleType' }));
								}	
	
								if(option.value === 1 && (wpsState.tableData[i].sampleType.label === 'DNA fragment > 1 Kb')){
									dispatch(editWpsRow({ index:i, value:'', property:'sampleType' }));
								}
							}
						}
					}}
					selectedOption={wpsState.serviceOption}
					type={2}
					clearServiceOption={() => dispatch(clearWpsServiceOption(null))}
					/>
				</div>
				{errors.serviceOption && (
					<span className='text-[14px] text-red-500 font-bold'>{errors.serviceOption}</span>
				)}
			</div>
            <div className='flex flex-col'>
              <p className='text-lg font-black text-[var(--color-primary-purple)] mb-3'>
                Number of Samples:
              </p>
              <div className='flex justify-start items-center'>
                <input
                  className='w-52 border-2 border-[var(--color-primary-purple)] rounded-sm p-2'
                  placeholder='Enter number'
                  id='reactions'
                  min={0}
                  value={wpsState.sampleAmount}
                  onChange={(event) => {
                    setErrors({
                      ...errors,
                      sampleAmount: "",
                    });
                    dispatch(setWpsSampleAmount(event.target.value));
                  }}
                  type='number'
                />
                <button
                  onClick={() =>{ 
                    setErrors({...errors, sampleAmount:''})
                    handleSubmit(wpsState.sampleAmount)}}
                  id='sampleAmountButton'
                  className='text-4xl text-[var(--color-primary-purple)] pl-4'
                >
                  <IoIosArrowDroprightCircle />
                </button>
              </div>
              {errors.sampleAmount && (
                <span className='text-[14px] text-red-500 font-bold'>{errors.sampleAmount}</span>
              )}
            </div>
          </div>
          <div className='flex flex-col items-end justify-end'>
            <div className='w-full flex items-start pl-11'>
              <p className='font-bold'>Prefer to work in Excel?</p>
            </div>
            <div>
              <p
                className='text-[var(--color-primary-purple)]  font-bold underline cursor-pointer text-left pl-11'
                onClick={downloadTemplate}
              >
                Download Excel Template
              </p>
            </div>
          </div>
        </div>
        <div className='my-4'>
          <table className='border-0 border-black w-full'>
            <thead className="whitespace-nowrap">
              <tr className='bg-gray-200 h-16'>
                <th className='bg-white border-none text-white'></th>
                <th className=' font-bold border-[1px] border-gray-300 text-center'>#</th>
                {/* <th className=' font-bold border-[1px] border-gray-300 xl:min-w-[410px] '> */}
                <th className=' font-bold border-[1px] border-gray-300  '>
                  <div className='relative flex justify-center gap-[7px] items-center mx-1 xl:mx-4'>
                    <p>Sample ID</p>
                    <AiOutlineInfoCircle
                      size={20}
                      className='text-xl cursor-pointer mx-2'
                      onClick={handleSampleIDOpen}
                    />
                      <button
                        onClick={seqSampleId}
                        className={`group text-sm p-1 rounded-md`}
                      >
                        <FaArrowCircleDown className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-36 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Fill All
                        </p>
                      </button>
                      <button 
                      onClick={clearAllSampleId} 
                      className={`group text-sm p-1 rounded-md`}>
                        <FaRegTimesCircle className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-40 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Clear All
                        </p>
                      </button>
                  </div>
                  {isSampleIDModalOpen && (
                    <Modal isOpen={isSampleIDModalOpen} onClose={handleSampleIDClose}>
                      <div className='flex flex-col items-start'>
                        <h2 className='mb-3 text-xl'>Sample ID</h2>
                        <p className='font-semibold mb-3 text-left'>
                          Clearly label tubes with permanent marker or printing label(s).
                          <br /> ser simple and short IDs. Plates must have clearly written IDs
                          <br /> on their sides, or ID labels attached. Sample IDs will consist of
                          <br /> plate ID and well position, e.g. A1, B2, etc.
                        </p>
                      </div>
                    </Modal>
                  )}
				</th>
				<th className=' font-bold border-[1px] border-gray-300 text-center'>
					<div className='relative flex justify-center gap-[7px] items-center mx-1 xl:mx-4'>
						<p>Sample Type</p>
						{/* <AiOutlineInfoCircle
						size={20}
						className='text-xl cursor-pointer'
						onClick={handleSampleTypeOpen}
						/> */}
						<button
							onClick={seqSampleType}
							className={`group text-sm p-1 rounded-md`}
						>
							<FaArrowCircleDown className='text-[14px] xl:text-[16px] relative' />
							<p className='text-sm font-light left-26 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
								Fill All
							</p>
						</button>
						<button 
						onClick={clearAllSampleType} 
						className={`group text-sm p-1 rounded-md`}>
							<FaRegTimesCircle className='text-[14px] xl:text-[16px] relative' />
							<p className='text-sm font-light left-32 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
								Clear All
							</p>
						</button>
					</div>
					{/* {isSampleTypeModalOpen && (
						<Modal isOpen={isSampleTypeModalOpen} onClose={handleSampleTypeClose}>
						<div className='flex flex-col items-start text-left'>
							<h2 className='mb-3 text-xl'>Sample Type:</h2>
							<p className='font-semibold mb-3'>
								Need text here..
							</p>
						
						</div>
						</Modal>
					)} */}
				</th>
                {/* <th className=' font-bold border-[1px] border-gray-300 xl:min-w-[100px]'> */}
                <th className=' font-bold border-[1px] border-gray-300 '>
                  <div className='relative flex justify-center items-center mx-1 xl:mx-4 gap-[7px]'>
                    <p>Sample Conc. (ng/ul)</p>
                    <button
                        onClick={seqSampleConc}
                        className={`group text-sm p-1 rounded-md`}
                      >
                        <FaArrowCircleDown className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-36 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Fill All
                        </p>
                      </button>
                      <button 
                      onClick={clearAllSampleConc} 
                      className={`group text-sm p-1 rounded-md`}>
                        <FaRegTimesCircle className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-40 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Clear All
                        </p>
                      </button>
                  </div>
                </th>
                {/* <th className=' font-bold border-[1px] border-gray-300 text-center xl:min-w-[221px]'> */}
				
                {/* <th className=' font-bold border-[1px] border-gray-300 xl:min-w-[130px]'> */}
                <th className=' font-bold border-[1px] border-gray-300'>
                  <div className='relative flex justify-center items-center mx-1 xl:mx-4 gap-[7px]'>
                    <p>Est. Target Size (Kb)*</p>
                    <button
                        onClick={seqTargetSize}
                        className={`group text-sm p-1 rounded-md`}
                      >
                        <FaArrowCircleDown className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-36 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Fill All
                        </p>
                      </button>
                      <button 
                      onClick={clearAllTargetSize} 
                      className={`group text-sm p-1 rounded-md`}>
                        <FaRegTimesCircle className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-40 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Clear All
                        </p>
                      </button>
                  </div>
                </th>
                {/* <th className=' font-bold border-[1px] border-gray-300 xl:min-w-[221px]'> */}
                {/* <th className=' font-bold border-[1px] border-gray-300'>
                  <div className='relative flex justify-center gap-[7px] items-center mx-1 xl:mx-4'>
                    <p>Data Analysis</p>
                    <AiOutlineInfoCircle
                      size={20}
                      className='text-xl cursor-pointer mx-2'
                      onClick={handleAnalysisOpen}
                    />
                    <button
                        onClick={seqDataAnalysis}
                        className={`group text-sm p-1 rounded-md `}
                      >
                        <FaArrowCircleDown className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-36 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Fill All
                        </p>
                      </button>
                      <button 
                      onClick={clearAllDataAnalysis} 
                      className={`group text-sm p-1 rounded-md`}>
                        <FaRegTimesCircle className='text-[14px] xl:text-[16px] relative' />
                        <p className='text-sm font-light left-40 top-[-20px] absolute bg-white px-1 hidden group-hover:block pointer-events-none'>
                          Clear All
                        </p>
                      </button>
                  </div>
                  {isAnalysisModalOpen && (
                    <Modal isOpen={isAnalysisModalOpen} onClose={handleAnalysisClose}>
                      <div className='flex flex-col items-start text-left'>
                        <h2 className='mb-3 text-xl'>Data Analysis</h2>
                        <p className='font-semibold mb-3'>
                          <b>De Novo Assembly:</b> do not require a reference sequence.
                        </p>
                        <p className='font-semibold mb-3'>
                          <b>Map to Reference:</b> require reference sequences; please email
                          <br /> FASTA formal sequences to ngs@acgtinc.com, with Order
                          <br /> Number and Sample ID clearly identified. One reference
                          <br /> sequence per sample.
                        </p> 
                      </div>
                    </Modal>
                  )}
                </th> */}
                {wpsState.tableData.length > 0 && 
                          <th colSpan={1} className="bg-white"><p className="w-[20px]"></p></th>
                      } 
              </tr>
            </thead>
            <tbody>{renderedRows}</tbody>
			</table>
			{showSampleIdError &&
				<p className="text-red-500 text-lg font-bold float-left ml-[80px] mb-2 w-full">Sample ID length: 1-30 characters</p>
			}
        </div>
         <div className=' my-7 px-[50px] xl:pl-[85px]'>
          <p>*Est. Target Size: Should be between 1Kb to 200Kb. Please contact us at <a className="underline text-blue-600" href="mailto:wps@acgtinc.com">wps@acgtinc.com</a> for custom requests if the target size is above 200Kb.</p>
          <p>Concentrations for each service type are specified below, please prep your sample(s) accordingly.</p>
            <table className="mt-2 w-[70%]">
              <thead>
                <tr>
					<th className="border border-1 w-[25%] px-2">Target Type</th>
					<th className="border border-1 w-[25%] px-2">Target Size</th>
                  <th className="border border-1 w-[25%] px-2">Concentration</th>
                  <th className="border border-1 w-[25%] px-2">Volume</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-1 px-2">Standard</td>
                  <td className="border border-1 px-2">1 to 25 kb</td>
					<td className="border border-1 px-2">100 ng/uL</td>
					<td className="border border-1 px-2">{">"} 5 uL</td>
                </tr>
                <tr>
                  <td className="border border-1 px-2">Large</td>
                  <td className="border border-1 px-2">26 to 125 kb</td>
					<td className="border border-1 px-2">100 ng/uL</td>
					<td className="border border-1 px-2">{">"} 5 uL</td>
                </tr>
                <tr>
                  <td className="border border-1 px-2">Very Large</td>
                  <td className="border border-1 px-2">126 to 200 kb</td>
					<td className="border border-1 px-2">100 ng/uL</td>
					<td className="border border-1 px-2">{">"} 15 uL</td>
				</tr>
				<tr>
					<td className="border border-1 px-2">Colony/Culture</td>
					<td className="border border-1 px-2"></td>
					<td className="border border-1 px-2"></td>
					<td className="border border-1 px-2">Plate or 100 uL</td>
				</tr>
              </tbody>
            </table>
			<p className="mt-2">If you are providing culture/colony samples, please see Instructions for Sample Preparation and Shipping.</p>
          </div>
          {/* <div className="mt-12">
            <p className='text-lg  font-black text-[var(--color-primary-purple)] mb-3'>
              Would you like to provide Map to Reference sequence?
            </p>
            <div className='flex items-center'>
              <input
                type='radio'
                id='yes'
                value={1}
                name='consensus'
                checked={wpsState.wpsMTR === 1}
                onChange={handleMTR}
                className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
              />
              <label htmlFor='yes' className='text-[#1F1F1F] font-bold 1 mr-5'>
                Yes
              </label>
              <input
                type='radio'
                id='no'
                value={2}
                name='consensus'
                checked={wpsState.wpsMTR === 2}
                onChange={handleMTR}
                className='m-2 h-5 w-5 accent-[var(--color-primary-purple)] cursor-pointer'
              />
              <label htmlFor='no' className='text-[#1F1F1F] font-bold'>
                No
              </label>
            </div>
            {wpsState.wpsMTR === 1 && 
            <p className="font-semibold mt-3"> <b>Map to Reference:</b> require reference sequences; please email FASTA formal sequences to wps@acgtinc.com, with Order Number and Sample ID clearly identified. One reference sequence per sample.</p>
            }
          </div> */}
        <div className='my-[40px] flex justify-between'>
          <div className='flex flex-col w-[60%]'>
            <p className='text-lg font-black text-[var(--color-primary-purple)] mb-3'>
              Additional Comments
            </p>
           
            <textarea
              required
              // placeholder='Add comments here'
              placeholder={`If your samples are from a previous order and you'd like to re-use them for further sequencing in this order, please indicate the order type and order number here or email us at wps@acgtinc.com`}
              value={wpsState.comments}
              className='w-full h-[180px] resize-none border-2 border-[var(--color-primary-purple)] rounded-sm gap-2 px-4 pt-4 pb-9'
              onChange={handleComments}
            />
          </div>
          <div className='p-3 px-5'>
            {/* <p className='font-bold text-[#1F1F1F]'>*Indicates required fields.</p> */}
            <p className='font-bold text-[#1F1F1F]'>
              See{" "}
				<Link to={"https://acgtinc.com/wp-content/uploads/2026/08/WPS-Sample-Submission-Guidelines_2026.pdf"}  target="_blank" rel="noopener noreferrer" className='text-[var(--color-primary-purple)] underline'>
                Instructions for Sample Preparation and Shipping
              </Link>{" "}
              for additional information.
            </p>

            <div className='flex items-start pt-[30px] justify-start gap-[10px]'>
              <input
                type='checkbox'
                id='checkbox'
                checked={isChecked}
                onChange={() => {
                  setErrors({...errors, isChecked: ''})
                  setIsChecked(!isChecked);
                }}
                className='hidden'
              />
              <label htmlFor='checkbox' className='cursor-pointer flex items-center mx-1 '>
                {isChecked ? (
                  <div className=' text-2xl text-[var(--color-primary-purple)]'>
                    <MdCheckBox />
                  </div>
                ) : (
                  <div className=' text-2xl text-[var(--color-primary-purple)]'>
                    <MdCheckBoxOutlineBlank />
                  </div>
                )}
              </label>
              <div className='flex flex-col'>
                <p className='font-bold'>
                  I have read the instructions.
                </p>
                {errors.isChecked && (
                  <p className='text-[14px] text-red-500 font-bold'>{errors.isChecked}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <AutoSave 
        currentOrderForm={wpsWhole} 
        page={page} 
        handleNextPage={validateAllInputs} 
        steps={5} 
        setTableData={fillTable}
        passMessage={passMessage}
        />

        </div>
        

      </div>
    </>
  );
};

export default SampleInformation;
